﻿import { useState, useEffect } from 'react';
import { products } from '../Endpoints'

export const useFacilityProducts = (bookingFlowContext, productSelection, lang, date) => {
  //{ item: { Text: lang.chooseproduct, Id: emptyGuid, ZoneAndProduct: emptyGuid, initial: true }, required: true, elementType: 'select' }

  const [productOptions, setProductOptions] = useState(null);
  const [hasPrivatePmcs, setHasPrivatePmcs] = useState(false);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    let isSubscribed = true;

    const getFacilityProducts = async () => {
      setPending(true);
      const returnedProducts = await products.getProducts(
        {
          bookingController: bookingFlowContext.episerver.bookingController,
          fId: bookingFlowContext.facility.id,
          productType: bookingFlowContext.episerver.productType,
          lang: lang,
          availabilityFrom: date.date,
        },
        bookingFlowContext.useMockedData
      );

      // setProductOptions((returnedProducts.status === 200 && isSubscribed) ? [productSelection.item, ...returnedProducts.body] : []);
      if (isSubscribed) {
        if (returnedProducts.status === 200) {
          setProductOptions(returnedProducts.body.Places);
          setHasPrivatePmcs(returnedProducts.body.HasPrivatePmcs ?? false);
        } else setProductOptions([]);
        setPending(false);
      }
    }

    getFacilityProducts();
    return () => isSubscribed = false;
  }, [date]);

  return [productOptions, pending, hasPrivatePmcs];
}
